import FetchHelpers from '../../utils/FetchHelpers';
import formUrl from '../../utils/routes';
import { decamelize } from '../../utils/keysConverter';

export default {
  load() {
    const url = formUrl(`/api/v1/admin/cohorts`);
    return FetchHelpers.get(url);
  },
};
